import SuccessImage from "@/shared/images/success.png";
import { useFrameworkWizardStore } from "./states";
import { Spinner } from "@nextui-org/react";
export default function SuccessScreen({
  onViewAgents,
  onStartAssessment,
  isLoading,
}: {
  onViewAgents?: () => void;
  onStartAssessment?: () => void;
  isLoading: boolean;
}) {
  const { frameworkName } = useFrameworkWizardStore();

  return (
    <div className="w-full h-full flex items-center justify-center bg-gradient-to-b from-zinc-100 via-pink-100/80 to-indigo-100/80">
      <div className="w-full h-full bg-white justify-center border border-zinc-200 rounded-xl shadow-sm flex flex-col items-center gap-8 p-6 md:p-10">
        <div className="flex items-center justify-center mb-2">
          <div className="rounded-full flex items-center justify-space-between h-[240px]">
            <div className="rounded-full flex items-center justify-space-between h-[240px]">
            {isLoading ? (
              <Spinner size="lg" className="m-auto" classNames={{wrapper: "h-24 w-24", }}/>
            ) : (
              <img src={SuccessImage} alt="Success" className="h-[240px] w-[240px]" loading="lazy" decoding="async" />
            )}
          </div>
          </div>
        </div>

        {/* Text Section */}
        <div className="flex flex-col items-center gap-4 w-full">
          <h2 className="text-lg font-normal text-zinc-900 text-center w-full">
            {frameworkName}
            {' '}
            {isLoading
              ? 'Gap Assessment Agent is Under Review'
              : 'Gap Assessment Agent Published Successfully!'}
          </h2>
          {isLoading ? (
            <p className="text-sm text-zinc-500 text-center w-full">
              This process might take up to 10 minutes. Thank you for your
              patience!
            </p>
          ) : (
            <p className="text-sm text-zinc-500 text-center w-full">
              All members in your organization can now run assessments using
              this Agent.
              <br />
              To start an assessment, open Gap Assessment Agent and select this
              framework.
            </p>
          )}
        </div>

        {/* Button Section */}
        {!isLoading && (
          <div className="flex flex-row gap-2 mt-4">
            <button
              className="px-4 py-2 border border-blue-600 rounded-md text-blue-600 font-medium text-base hover:bg-blue-50 transition"
              onClick={onViewAgents}
              type="button"
            >
              View Agents
            </button>
            <button
              className="px-4 py-2 border border-blue-600 rounded-md text-blue-600 font-medium text-base hover:bg-blue-50 transition"
              onClick={onStartAssessment}
              type="button"
            >
              Start New Assessment
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
